import { construirFecha } from "../utils/ConstruirFecha";
import { esFechaValida } from "../utils/EsFechaValida";
import { validarCUIT } from "../utils/ValidarCuit";
import { validarFechaNoFutura } from "../utils/ValidarFechaNoFutura";

export function validarInstrumentos(instrumentos) {
  const errors = [];

  instrumentos.forEach((inst, i) => {
    const importe = parseFloat(inst.importe);
    if (importe > 0 || inst.tipo_id || inst.banco_id || inst.nro_comprobante) {
      if (!inst.tipo_id) errors.push(`Instrumento ${i + 1}: falta el tipo`);

      if (!inst.banco_id) errors.push(`Instrumento ${i + 1}: falta el banco`);

      if (!inst.nro_comprobante.length || inst.nro_comprobante.trim() === "") {
        errors.push(
          `Instrumento ${i + 1}: el numero de comprobante no puede estar vacio`,
        );
      }

      if (isNaN(importe) || importe <= 0) {
        errors.push(`Instrumento ${i + 1}: el importe debe ser mayor a 0`);
      }

      const requiereCuitFirma =
        inst.tipo_id === 4 || inst.tipo_id === 3 || inst.tipo_id === 6;
      if (requiereCuitFirma && !inst.cuit_firma) {
        errors.push(
          `Instrumento ${
            i + 1
          }: falta CUIT firma para cheque/echeq/transferencia`,
        );
      } else if (requiereCuitFirma && !validarCUIT(inst.cuit_firma)) {
        errors.push(`Instrumento ${i + 1}: el CUIT firma es invalido`);
      }

      const requiereFechaDePago = inst.tipo_id === 3 || inst.tipo_id === 6;
      if (requiereFechaDePago && !inst.fecha_de_pago) {
        errors.push(
          `Instrumento ${i + 1}: falta la fecha de pago para cheque/e-cheq`,
        );
      }

      if (!inst.dia || !inst.mes || !inst.ano) {
        errors.push(`Instrumento ${i + 1}: falta la fecha de emisión`);
      } else {
        if (!esFechaValida(inst.dia, inst.mes, `20${inst.ano}`)) {
          errors.push(`Instrumento ${i + 1}: fecha invalida.`);
        } else {
          const fechaInst = construirFecha(inst.dia, inst.mes, `20${inst.ano}`);
          if (inst.tipo_id === 4 && !validarFechaNoFutura(fechaInst)) {
            //El 4 es transferencia, hago esto pq tanto los cheques como los echeq pueden tener fecha futura
            errors.push(`Instrumento ${i + 1}: la fecha no puede ser futuro.`);
          }
        }
      }
    }
  });

  return {
    isValid: errors.length === 0,
    errors,
  };
}
